import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchCompositionList } from '@store/actions/CompositionAction';
import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { validateFloatNumber } from '@utils/Util';

const GSM = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchCompositionList());
	}, []);

	const handleChangeMin = (e) => {
		let { value, name } = e.target;
		let data = {
			name: 'minGsm',
			type: 'text',
			key: value,
			value: value,
			identifier: name
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	const handleChangeMax = (e) => {
		let { value, name } = e.target;
		let data = {
			name: 'maxGsm',
			type: 'text',
			key: value,
			value: value,
			identifier: name
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="card">
			<div className="card-header" id="headingSeven">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#collapseGSM"
						aria-expanded="false"
						aria-controls="collapseGSM"
					>
						Weight
					</button>
				</h5>
			</div>

			<div
				id="collapseGSM"
				className="collapse"
				aria-labelledby="headingSeven"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="container range-input pt-2 px-0">
						<div className="row">
							<div className="col-md-6 pr-1">
								<div className="form-group mb-0">
									<label htmlFor="Minimum">Minimum</label>
									<input
										type="number"
										id="Minimum"
										onChange={(e) => handleChangeMin(e)}
										onKeyPress={validateFloatNumber}
									/>
								</div>
							</div>
							<div className="col-md-6 pl-1">
								<div className="form-group mb-0">
									<label htmlFor="Maximum">Maximum</label>
									<input
										type="number"
										id="Maximum"
										onChange={(e) => handleChangeMax(e)}
										onKeyPress={validateFloatNumber}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GSM;
